<template>
  <div class="p-4">
    <h3 class="mb-base"><span class="text-primary">{{orgData.name}}</span> Admins</h3>
    <div v-if="!isCurrentUserSubAdmin" class="my-base-large">
      <h5 class="mb-3">Add Admin</h5>
      <div class="mb-3">
        <vs-input
          v-validate="'required|email|min:3'"
          data-vv-validate-on="blur"
          :disabled="!isUserLoggedIn"
          name="Email"
          placeholder="Email Address"
          icon-no-border
          icon="icon icon-mail"
          icon-pack="feather"
          v-model="email"
          class="w-full lg:w-1/2"
          @keyup="adminExists()"
        />
        <span v-if="adminAlreadyExists" class="text-danger text-sm"
          >Admin already exists</span
        >
        <span v-else class="text-danger text-sm">{{
          errors.first("Email")
        }}</span>
      </div>
      <vs-button
        class="invite-btn"
        :disabled="adminAlreadyExists || !validEmail"
        @click.stop="inviteAdmin()"
        >Send Invite</vs-button
      >
    </div>
    <div>
      <h5 class="mb-3">Admins</h5>
      <vs-table :data="subAdmins">
        <template slot="thead">
          <vs-th> Email </vs-th>
          <vs-th> Name </vs-th>
          <vs-th> Max Role </vs-th>
          <vs-th> Status </vs-th>
          <vs-th v-if="!isCurrentUserSubAdmin"> Revoke Access </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-if="!isCurrentUserSubAdmin" key="super-admin-data">
            <vs-td :data="userData.email">
              <vs-row vs-align="center"
                ><div class="float-leftt mr-3">{{ userData.email }}</div>
                <vs-chip color="primary">It's you</vs-chip></vs-row
              >
            </vs-td>

            <vs-td v-if="userData && userData.firstName" :data="userData.firstName">
              {{ userData.firstName }} {{ userData.lastName }}
            </vs-td>

            <vs-td data="Super Admin">
              <small>Super Admin</small>
            </vs-td>

            <vs-td data="Active">
              <vs-chip color="success">Active</vs-chip>
            </vs-td>

            <vs-td v-if="!isCurrentUserSubAdmin" data="Super admin cannot be removed">
              <small>Super admin cannot be removed</small>
            </vs-td>
          </vs-tr>

          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>

            <vs-td v-if="data[indextr].userData && data[indextr].userData[0] && data[indextr].userData[0].firstName" :data="data[indextr].userData[0].firstName">
              {{ data[indextr].userData[0].firstName }} {{ data[indextr].userData[0].lastName }}
            </vs-td>
            <vs-td v-else>

            </vs-td>

            <vs-td data="Sub-Admin">
              <small>Sub-Admin</small>
            </vs-td>

            <vs-td :data="data[indextr].status">
              <vs-chip v-if="data[indextr].status === 'active'" color="success"
                >Active</vs-chip
              >
              <vs-chip v-else color="danger">Pending</vs-chip>
            </vs-td>

            <vs-td v-if="!isCurrentUserSubAdmin">
              <vs-button color="danger" size="small" @click.stop="revokeSubAdmin(data[indextr]._id, data[indextr].email)"
                >Revoke</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      adminAlreadyExists: false,
      isCurrentUserSubAdmin: true
    };
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    subAdmins() {
      if (this.$store.state.organization.orgData.subAdmins)
        return this.$store.state.organization.orgData.subAdmins;
      else return [];
    },
    validEmail() {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.email).toLowerCase());
    },
    // isCurrentUserSubAdmin() {
    //   if(!(this.orgData && this.orgData._id)) return true;
    //   else if(this.orgData.subAdmins && this.orgData.subAdmins.findIndex(sa => sa.email === this.userData.email) !== -1) return true;
    //   return false;
    // }
  },
  watch: {
    orgData() {
      if(this.orgData.subAdmins && this.orgData.subAdmins.findIndex(sa => sa.email.toLowerCase() === this.userData.email.toLowerCase()) === -1) {
        this.isCurrentUserSubAdmin = false;
      }

    }
  },
  methods: {
    adminExists() {
      if (this.email.toLowerCase() === this.userData.email.toLowerCase()) {
        this.adminAlreadyExists = true;
      } else {
        this.$store
          .dispatch("organization/fetchOrganizationAdminByEmail", {
            email: this.email.toLowerCase(),
            organizationId: this.organizationId,
          })
          .then((res) => {
            if (res.data.total > 0) {
              this.adminAlreadyExists = true;
            } else {
              this.adminAlreadyExists = false;
            }
          });
      }
    },
    inviteAdmin() {
      this.$vs.loading();

      const payload = {
        email: this.email ? this.email.toLowerCase() : 'unexpectederror@getboarded.tech',
        status: false,
        organizationId: this.organizationId,
        maxRole: "sub-admin",
        organizationName: this.orgData.name,
      };

      this.$store
        .dispatch("organization/inviteOrganizationAdmin", payload)
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Add Sub-Admin to Organization, Invitation Sent",
            color: "primary"
          });
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Add Sub-Admin to Organization, Invitation could not be sent",
            color: "danger"
          });
          throw err;
        });
      
      this.email = null;
    },
    revokeSubAdmin(orgSubAdminId, subAdminEmail) {
      this.$store.dispatch("organization/revokeSubAdmin", { orgSubAdminId, subAdminEmail, organizationId: this.orgData._id })
      .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sub-Admin access revoked.",
            color: "primary"
          });
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Cannot revoke Sub-Admin access",
            color: "danger"
          });
          throw err;
        });
    }
  },
  mounted() {
    if(this.orgData._id && this.orgData.subAdmins && this.orgData.subAdmins.findIndex(sa => sa.email.toLowerCase() === this.userData.email.toLowerCase()) === -1) {
        this.isCurrentUserSubAdmin = false;
    }
  },
  created() {
    if(this.orgData._id && this.orgData.subAdmins && this.orgData.subAdmins.findIndex(sa => sa.email.toLowerCase() === this.userData.email.toLowerCase()) === -1) {
        this.isCurrentUserSubAdmin = false;
    }
  }
};
</script>

<style scoped>
.my-base-large {
  margin: 3rem auto 4rem auto;
}

.invite-btn {
  border-radius: 4px;
}

.vs-con-table >>> .vs-table--not-data {
  display: none!important;
}
</style>